import { DragIndicator24 } from '@ws/shared/icons';
import { TEntity } from '@ws/shared/types';

import { useSpecialDrag } from '../../hooks';

import styles from './DragNDrop.module.css';

interface Props {
  node: TEntity;
  children?: (handler: JSX.Element) => JSX.Element;
}

export function ItemDragWrapper({ node, children }: Props) {
  const [, drag, dragPreview] = useSpecialDrag(node);

  const handler = (
    <div className={styles['drag-handler']} ref={drag}>
      <DragIndicator24 />
    </div>
  );

  if (!children) return null;

  return <div ref={dragPreview}>{children(handler)}</div>;
}
